module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0071.jpg?v=408143f0";